<template>
  <p
    :class="[
      sizeCustomize,
      textAlignCustomize,
      weightCustomize,
      hasColor ? colorCustomize : 'text-ontick-carbon-900 dark:text-gray-300',
    ]"
  >
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: "ontick-text",
  props: {
    size: {
      type: String,
      default: "sm",
    },
    weight: {
      type: String,
      default: "normal",
    },
    color: {
      type: String,
      // default: "black",
      validator: function (value) {
        return (
          [
            "black",
            "gray",
            "silver",
            "blue",
            "blue-ligth",
            "dark-blue",
            "white",
            "green",
            "red",
            "yellow",
          ].indexOf(value) !== -1
        );
      },
    },
    align: {
      type: String,
      default: "left",
      validator: function (value) {
        return ["left", "center", "right"].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    sizeCustomize() {
      return {
        [`text-${this.size}`]: true,
      };
    },
    weightCustomize() {
      return {
        [`font-${this.weight}`]: true,
      };
    },
    hasColor() {
      return this.color ? true : false;
    },
    colorCustomize() {
      return {
        "text-ontick-carbon-500": this.color == "black",
        "text-gray-400": this.color == "gray",
        "text-gray-300": this.color == "white",
        "text-ontick-blue-500": this.color == "blue",
        "text-ontick-green-500": this.color == "green",
        "text-ontick-red-500": this.color == "red",
        "text-ontick-yellow-500": this.color == "yellow",
        "text-ontick-font-nineth": this.color == "blue-ligth",
        "text-ontick-font-tenth": this.color == "silver",
      };
    },
    textAlignCustomize() {
      return {
        [`text-${this.align}`]: true,
      };
    },
  },
};
</script>
